const deliveryUnit = [
  {
    deliveryunit: 'Cargo A',
    frequency: '1',
    quantitymin: '44,000',
    quantitymax: '45,000',
    quantitymb: '0',
    princingperiod: 'Fixing Date',
    indexprice: 'Argus Singapore',
    otherindexprice: 'Argus Singapore',
    correlation: '1',
    publishindexpricefrom: '12/01/2025',
    publishindexpriceto: '12/01/2025',
    schemaBLdate: '2-1-2',
  },
];

const incoTermTable = [
  {
    type: 'FOB',
    port: '',
    route: 'Straits',
    locationfrom: '-',
    qtyfrom: '-',
    locationto: 'Singapore',
    qtyto: '-',
    datefrom: '06/01/2025',
    dateto: '08/01/2025',
    timeline: 'ALD',
    alpha: 'α1',
  },
  {
    type: 'FOB',
    port: 'Multi Port',
    route: 'Straits',
    locationfrom: 'Singapore',
    qtyfrom: '-',
    locationto: 'Malaysia',
    qtyto: '-',
    datefrom: '06/01/2025',
    dateto: '08/01/2025',
    timeline: 'ALD',
    alpha: 'α2',
  },
  {
    type: 'CFR',
    port: 'Multi Port',
    route: 'Straits',
    locationfrom: 'Tanjung Gerem',
    qtyfrom: '20',
    locationto: 'Jakarta',
    qtyto: '18',
    datefrom: '01/01/2025',
    dateto: '03/02/2025',
    timeline: 'ADD',
    alpha: 'α3',
  },
];

export { incoTermTable, deliveryUnit };
